import { render, staticRenderFns } from "./FormUserRole.vue?vue&type=template&id=211e1462"
import script from "./FormUserRole.vue?vue&type=script&lang=js"
export * from "./FormUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports